export const VERITASON_WALLET_TRANSFER_ENABLED = process.env.REACT_APP_VERITASON_WALLET_TRANSFER_ENABLED === 'true';

export const PIN_CHANGE_ENABLED = process.env.REACT_APP_PIN_CHANGE_DISABLED !== 'true';

export const PAY_PASSWORD_CHANGE_ENABLED = process.env.REACT_APP_PAY_PASSWORD_CHANGE_DISABLED !== 'true';

export const FAST_WALLET_TRANSFER_ENABLED = process.env.REACT_APP_FAST_WALLET_TRANSFER_ENABLED === 'true';
// New PIN/email authorization requires a separate server policy; no UI is enabled yet.
export const WALLET_ADDITIONAL_AUTH_ENABLED = false;

// Routing capability only; required authentication is always decided by the server.
export const COMMON_LOGIN_SECURITY_ENABLED = process.env.REACT_APP_COMMON_LOGIN_SECURITY_ENABLED === 'true';

// PIN-only adapter capability; server DB policy controls authentication.
export const PIN_POLICY_ENABLED = process.env.REACT_APP_PIN_POLICY_ENABLED === 'true';

// UI capability only. Server policy still decides wallet eligibility, availability and PIN requirements.
export const INTERNAL_WALLET_TRANSFER_ENABLED = process.env.REACT_APP_INTERNAL_WALLET_TRANSFER_ENABLED === 'true';
